import React from 'react'
import { AppContext } from '../context/AppContext';
import { useState, useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import { Spinner, Button, Badge, Table, Container, Row, Col, Modal, Form } from 'react-bootstrap';

const TenantListing = () => {

  const formDefault = {};
  const [formModal, setFormModal] = useState(formDefault);
  const modalForm = useRef(null);

  const { setToken, token, setUser, currentUser, setLoadingApp } = useContext(AppContext);
  const[data, setdata] = useState(null); 
  const[error, setError] = useState(null); 

  const [selectedItemObj, setSelectedItemObj] = useState(null);
  const [ShowEditModal, setShowEditModal] = useState(false);
  const [refresh, setRefresh] = useState(false);



  useEffect(()=>{

    console.log(currentUser);
    //if (currentUser && currentUser.accesstype !== "admin") return;

    let baseURL = process.env.REACT_APP_API_BASE_URL + 'api/Tenants';              
      let headers = {
        'Content-Type': 'application/json',  
        'Authorization': 'Bearer '+ token ,    
      };

    axios.get(baseURL,{headers})        
      .then((Response)=>{
          setdata(Response.data);

      }).catch(error => {
          setError(error);     
          console.log({error})         
      });

},[refresh])

const handleedit=(item)=>{
    //alert(item.tenantId);
    setSelectedItemObj(item);

    const selFormModal = {...formModal,
        id : item.id,
        tenantId : item.tenantId,
        name : item.name,
        phone : item.phone,
        address : item.address,
        hostname : item.hostname,
        displayName : item.displayName,
        email : item.email,
        adminPassword : item.adminPassword,
        publicPassword : item.publicPassword,
    }

    setFormModal(selFormModal);

    setShowEditModal(true)

}

const handleClose=()=>{
    setShowEditModal(false);
}

// const handleSubmit=()=>{
//     //setShowEditModal(false);
// }


const handleSubmit = (event) => {
    const form = event.currentTarget;
    // if (form.checkValidity() === false) {
    //   event.preventDefault();
    //   event.stopPropagation();
    //   setValidated(true);
    //   return;
    // }

    // setValidated(false);        

    event.preventDefault();

    let mode = modalForm.current.querySelector('#mode').value;
    let tenantId = modalForm.current.querySelector('#tenantId').value;
    let name = modalForm.current.querySelector('#name').value;
    let sphone = modalForm.current.querySelector('#phone').value;
    let email = modalForm.current.querySelector('#email').value;
    let address = modalForm.current.querySelector('#address').value;
    //let hostname = modalForm.current.querySelector('#hostname').value;
    //let displayName = modalForm.current.querySelector('#displayName').value;
    let publicPassword = modalForm.current.querySelector('#publicPassword').value;
    let adminPassword = modalForm.current.querySelector('#adminPassword').value;
   
  console.log(mode);
  //return

    const frmFormData = new FormData();

        if(mode !== "add"){      
            frmFormData.append("Id", selectedItemObj.id)     
        }
    
        frmFormData.append("Address", address);     
        frmFormData.append("DisplayName", name);     
        frmFormData.append("Email", email);     
        frmFormData.append("Hostname", ""); 
        frmFormData.append("Name", name);     
        frmFormData.append("Phone", sphone??"");     
        frmFormData.append("TenantId", tenantId); 
        frmFormData.append("AdminPassword", adminPassword); 
        frmFormData.append("PublicPassword", publicPassword); 
    

      const sURL = process.env.REACT_APP_API_BASE_URL + 'api/Tenants';

      
      const headers = {
        'Content-Type': 'application/json',  
        'Authorization': 'Bearer '+ token ,      
      };

      axios.post(sURL,frmFormData,{headers})      
      .then((Response)=>{
          
          setRefresh(!refresh)
          setShowEditModal(false);
          

      }).catch(error => {
          setError(error); 
      });
  
  };



const handleAddNew=()=>{
    //alert('asdadad');

    const selFormModal = {...formModal,
        id : null,
        tenantId : null,
        name : null,
        phone : null,
        address : null,
        hostname : null,
        displayName : null,
        email : null,
        adminPassword : null,
        publicPassword : null,
        mode : "add",
    }

    setFormModal(selFormModal);
    setShowEditModal(true)


}



// function xxhandleedit(obj){
    
//     setSelectedItemObj(obj);

//     // const selFormModal = {...formModal,
//     //     notification : obj.notificationText,
//     //     badgetext : obj.badgeText,
//     //     heelname : obj.heelDaneDoneteeName,
//     //     heelmobile : obj.heelDaneDoneteePhone,
//     //     heelmobilealt : obj.heelDaneDoneteePhoneAlt,
//     //     dahawalaname : obj.dahawalDaneDoneteeName,
//     //     dahawalamobile : obj.dahawalDaneDoneteePhone,
//     //     dahawalamobilealt : obj.dahawalDaneDoneteePhoneAlt,
        
//     // }

//     // setFormModal(selFormModal);

//     setShowEditModal(true)    
      
// }




  return (
    <>
    <Container fluid="md" style={{marginTop:'5px'}}>
    <Row>
        <Col style={{textAlign:"center", margin:"10px"}}>
            <h3>Organization Settings</h3>            
        </Col>        
    </Row>
    <Row>        
        <Col style={{textAlign:"right", margin:"10px"}}>
            <Button onClick={handleAddNew}>+ Add New Organization</Button>          
        </Col>

    </Row>

    <Row>
        <Col>         
          <Table bordered hover striped responsive="sm" size='sm' variant="light">
            <thead>
              <tr key="header00">
                <th key="header0" valign='middle' style={{backgroundColor:"lightblue", fontSize:"15px", fontWeight:"bold", textAlign:"center"}}>TenantId</th>
                <th key="header1" valign='middle' style={{backgroundColor:'lightblue',fontSize:"15px", textAlign:"center"}}>Name</th>
                <th key="header2" valign='middle' style={{backgroundColor:'lightblue', textAlign:"center"}}>Phone</th>
                <th key="header3" valign='middle' style={{backgroundColor:'lightblue', fontSize:"15px", fontWeight:"bold", textAlign:"center"}}>Email</th>
                <th key="header5" style={{backgroundColor:'lightblue'}}></th>
              </tr>
            </thead>
            <tbody>

              {data && data.map((item)=>{   
              
                  return(
                      <>              
                      <tr key={item.tenantId} style={{fontSize:"15px"}} >
                        <td valign='middle'><strong>{item.tenantId}</strong></td>
                        <td valign='middle' style={{textAlign:"left",fontSize:"15px"}}>{item.name}</td>
                        <td valign='middle' style={{textAlign:"left",fontSize:"15px"}}>{item.phone}</td>
                        <td valign='middle' style={{textAlign:"left",fontSize:"15px"}}>{item.email}</td>
                        <td ><Button variant='outline-success' size='sm' onClick={()=>{handleedit(item)} }>Edit</Button> </td>
                      </tr>                
                </>                
                )         
              })}
              
            </tbody>
        </Table>
      </Col>
      </Row>


    </Container>

    {ShowEditModal && 
    <Modal show={ShowEditModal} onHide={handleClose} backdrop="static" aria-labelledby="contained-modal-title-vcenter" centered size='lg'> 
    <Form ref={modalForm} onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{formModal.mode === "add"? "Add" : "Edit"} Organization Data</Modal.Title>
        </Modal.Header>
       
        <Modal.Body>
                
                <Form.Group className="mb-3" >
                    <Form.Label>ID</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.tenantId} id="tenantId" />                   
                </Form.Group>

                <Form.Group className="mb-3" >
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.name} id="name" />                   
                </Form.Group>
                <Form.Group className="mb-3" >
                    <Form.Label>Phone</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.phone} id="phone" />                   
                </Form.Group>
                <Form.Group className="mb-3" >
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.email} id="email" />                   
                </Form.Group>
                <Form.Group className="mb-3" >
                    <Form.Label>address</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.address} id="address" />                   
                </Form.Group>
                {/* <Form.Group className="mb-3" >
                    <Form.Label>Host Name</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.hostname} id="hostname" />                   
                </Form.Group>
                <Form.Group className="mb-3" >
                    <Form.Label>Display Name</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.displayName} id="displayName" />                   
                </Form.Group>                                                      */}
                <Form.Group className="mb-3" >
                    <Form.Label>Public Passcode</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.publicPassword} id="publicPassword" />                   
                </Form.Group>                                                     
                <Form.Group className="mb-3" >
                    <Form.Label>Admin Passcode</Form.Label>
                    <Form.Control type="text" placeholder="" defaultValue={formModal.adminPassword} id="adminPassword" />                   
                </Form.Group> 

                <input type='hidden' value={formModal.mode} id="mode" />

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="success" type='submit'>
            Save
          </Button>
         
        </Modal.Footer> 
    </Form>
    </Modal>
}


    </>
  )
}

export default TenantListing